import a from "../utils/propValidator.mjs";
const t = {
  type: [String],
  default: "primary",
  validator: (r) => a(r, ["primary", "secondary"])
};
export {
  t as default
};
